import { Component } from 'react';
import { WebsiteLayout } from '../components/common/layout';
import { JobListing } from '../components/screens';
import { jobListings } from '../fixtures';
import { withRouter, useRouter } from 'next/router';
import { getQueryParameters } from '../util/index';
import SkeletonScreen from '@components/screens/SkeletonScreen';

class PageWithLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      listing: null
    };
  }

  componentDidMount() {
    const { listingId } = this.props;
    const listing = jobListings[listingId];

    this.setState({
      loading: false,
      listing
    })
  }


  render() {
    const { logout, user } = this.props;
    const { listing, loading } = this.state;
    const noJobsFound = !listing && !loading


    if (loading) return <WebsiteLayout><center><SkeletonScreen /></center></WebsiteLayout>
    if (noJobsFound) return <WebsiteLayout><center><SkeletonScreen noJobsFound={noJobsFound}/></center></WebsiteLayout>

    return (
      <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
        <JobListing listing={listing} />
      </WebsiteLayout>
    );
  }
}


function CustProps(props) {
  const router = useRouter();
  const { asPath } = router;
  const { id } = getQueryParameters(asPath)

  return <PageWithLayout listingId={id} router={router} />
}

export default withRouter(CustProps);
